import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { sendOrganizationEmail } from 'api/actions/userMetadata/userMetadataActions'
import { Mutations } from 'api/mutations.enum'
import {
    SendOrganizationEmailErrorResponse,
    SendOrganizationEmailPayload,
    SendOrganizationEmailResponse,
} from 'api/actions/userMetadata/userMetadataActions.types'

export const useSendOrganizationEmail = () => {
    const mutation = useMutation<
        SendOrganizationEmailResponse,
        AxiosError<SendOrganizationEmailErrorResponse>,
        SendOrganizationEmailPayload
    >({
        mutationKey: [Mutations.sendOrganizationEmail],
        mutationFn: sendOrganizationEmail,
    })

    return mutation
}
